import React from 'react';
import { ChevronDownIcon, ClockIcon, MapPinIcon, LayersIcon } from 'lucide-react';
import KPICard from './common/KPICard';
import { headlineKPIs, timeFilters, jurisdictionFilters, serviceCategoryFilters } from '../utils/mockData';
const TopBar = ({
  filters,
  onFilterChange
}) => {
  return <div className="w-full bg-slate-800 rounded-lg p-4" data-id="element-203">
      <div className="flex justify-between items-center mb-4" data-id="element-204">
        <div className="flex items-center" data-id="element-205">
          <h1 className="text-2xl font-bold mr-8" data-id="element-206">
            Presidential E-Government Dashboard
          </h1>
          <div className="flex gap-4" data-id="element-207">
            <div className="flex items-center gap-2 text-sm" data-id="element-208">
              <ClockIcon size={16} data-id="element-209" />
              <select className="bg-slate-700 border border-slate-600 rounded px-2 py-1" value={filters.time} onChange={e => onFilterChange('time', e.target.value)} data-id="element-210">
                {timeFilters.map(filter => <option key={filter.id} value={filter.id} data-id="element-211">
                    {filter.label}
                  </option>)}
              </select>
            </div>
            <div className="flex items-center gap-2 text-sm" data-id="element-212">
              <MapPinIcon size={16} data-id="element-213" />
              <select className="bg-slate-700 border border-slate-600 rounded px-2 py-1" value={filters.jurisdiction} onChange={e => onFilterChange('jurisdiction', e.target.value)} data-id="element-214">
                {jurisdictionFilters.map(filter => <option key={filter.id} value={filter.id} data-id="element-215">
                    {filter.label}
                  </option>)}
              </select>
            </div>
            <div className="flex items-center gap-2 text-sm" data-id="element-216">
              <LayersIcon size={16} data-id="element-217" />
              <select className="bg-slate-700 border border-slate-600 rounded px-2 py-1" value={filters.service} onChange={e => onFilterChange('service', e.target.value)} data-id="element-218">
                {serviceCategoryFilters.map(filter => <option key={filter.id} value={filter.id} data-id="element-219">
                    {filter.label}
                  </option>)}
              </select>
            </div>
          </div>
        </div>
        <div className="text-sm text-slate-300" data-id="element-220">
          Last updated: {new Date().toLocaleString()}
        </div>
      </div>
      <div className="grid grid-cols-5 gap-4" data-id="element-221">
        <KPICard title="Total E-Services" value={headlineKPIs.totalServices.value} target={headlineKPIs.totalServices.target} progress={headlineKPIs.totalServices.progress} format="number" type="progress" data-id="element-222" />
        <KPICard title="Service Requests" value={headlineKPIs.totalRequests.value} change={headlineKPIs.totalRequests.change} format="number" type="trend" data-id="element-223" />
        <KPICard title="Citizen Satisfaction" value={headlineKPIs.citizenSatisfaction.value} change={headlineKPIs.citizenSatisfaction.change} format="percent" type="trend" data-id="element-224" />
        <KPICard title="Revenue Collected" value={headlineKPIs.revenueCollected.value} change={headlineKPIs.revenueCollected.change} format="currency" type="trend" data-id="element-225" />
        <KPICard title="SLA Compliance" value={headlineKPIs.slaCompliance.value} change={headlineKPIs.slaCompliance.change} format="percent" type="trend" data-id="element-226" />
      </div>
    </div>;
};
export default TopBar;